import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { AlterRowTransformation } from 'app/model/dataflow/alterrowtransformation';
import { AlterRowAction } from 'app/model/dataflow/alterRowIfCondition';
import { AlterRowPlainObject } from 'worker/app-workers/shared/plainObjects/alterRow.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class AlterRowConvertor extends TransformConvertorBase {
    private get alterRowTransform(): AlterRowTransformation {
        return this.transformation as AlterRowTransformation;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        (this.transformObject as AlterRowPlainObject).conditions.forEach((condition) => {
            const ifCondition = this.alterRowTransform.createIfCondition();
            ifCondition.conditionExpression.expression = condition.expression;

            if (condition.conditionType === AlterRowAction.Insert) {
                ifCondition.action = AlterRowAction.Insert;
            }
            if (condition.conditionType === AlterRowAction.Update) {
                ifCondition.action = AlterRowAction.Update;
            }
            if (condition.conditionType === AlterRowAction.Delete) {
                ifCondition.action = AlterRowAction.Delete;
            }
            if (condition.conditionType === AlterRowAction.Upsert) {
                ifCondition.action = AlterRowAction.Upsert;
            }
        });
        super.postConvert();
        return this.transformation;
    }
}
